import { Button, IconButton } from '@apollo/orbit';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { WrapMaybe } from 'src/components/wrapMaybe/WrapMaybe';

interface TabSwitcherProps<Tab> {
  activeTab: Tab | null;
  onSelectTab: (tab: Tab) => void;
  tabs: ReadonlyArray<
    | Tab
    | {
        key: Tab;
        tooltipLabel: string;
        icon: React.ReactElement;
        dataTestId?: string;
      }
  >;
}

export const TabSwitcher = <Tab extends string>({
  tabs,
  activeTab,
  onSelectTab,
}: TabSwitcherProps<Tab>) => (
  <>
    {tabs.flatMap((tab) => {
      const key = typeof tab === 'string' ? tab : tab.key;
      const Component = typeof tab === 'string' ? Button : IconButton;

      return (
        <WrapMaybe
          key={key}
          on={typeof tab !== 'string'}
          element={
            <Tooltip
              label={typeof tab !== 'string' ? tab.tooltipLabel : undefined}
            />
          }
        >
          <Component
            isActive={key === activeTab}
            variant="hidden"
            size="sm"
            onClick={() => onSelectTab(key)}
            data-analytics-label={`tab_switcher ${key}`}
            data-analytics-category="Explorer"
            data-testid={typeof tab === 'string' ? undefined : tab.dataTestId}
            aria-label={`switch to ${key} tab`}
            icon={typeof tab === 'string' ? undefined : tab.icon}
          >
            {typeof tab === 'string' ? tab : undefined}
          </Component>
        </WrapMaybe>
      );
    })}
    <div className="flex-1" />
  </>
);
